import {
  DateField,
  Show,
  TabbedShowLayout,
  TextField,
  BooleanField,
  Tab,
  Loading,
  FunctionField,
  useRecordContext,
} from 'react-admin';
import { AdminCompanyResponseDto, AdminCompanyResponseDtoTypeEnum } from 'shared/api';
import { LABELS } from 'shared/constants/labels';
import { VARS } from 'shared/constants/vars';
import { CompaniesShowActions } from './ui/actions';
import Owner from './ui/owner';
import CompanyPatients from './ui/patients/patients';
import { Promocodes }from './ui/promocodes/promocodes';
import { SessionBalances } from './ui/session-balance/session-balances';
import Statistic from './ui/statistic';
import UploadPatients from './ui/upload/upload';

const Tabs = () => {
  const record = useRecordContext<AdminCompanyResponseDto>();

  if (!record) {
    return <Loading />;
  }

  return (
    <TabbedShowLayout>
      <Tab label="Детали компании">
        <TextField source="id" label={LABELS.companyId} sortable={false} />
        <TextField
          source="ownerId"
          label={LABELS.userId}
          sortable={false}
        />
        <TextField source="name" label={LABELS.companyName} sortable={false} />
        <FunctionField
          label={LABELS.companyType}
          render={(record: AdminCompanyResponseDto) => VARS.companyTypes[record.type] || record.type}
        />
        <BooleanField source="isArchive" label={LABELS.isArchive} sortable={false} />
        <DateField
          source="createdAt"
          label={LABELS.createdAt}
          sortable={false}
        />
      </Tab>
      <Tab label="Статистика">
        <Statistic />
      </Tab>
      <Tab label="Владелец компании">
        <Owner />
      </Tab>
      <Tab label="Сотрудники">
        <CompanyPatients companyId={record.id} />
      </Tab>
      <Tab label="Загрузка сотрудников">
        <UploadPatients />
      </Tab>
      {record.type === AdminCompanyResponseDtoTypeEnum.Promocode &&
        <Tab label="Промокоды">
          <Promocodes />
        </Tab>
      }
      {record.type === AdminCompanyResponseDtoTypeEnum.Balance &&
        <Tab label="Балансы консультаций">
          <SessionBalances />
        </Tab>
      }
    </TabbedShowLayout>
  );
}

export const CompaniesShow = () => {
  return (
    <Show actions={<CompaniesShowActions />}>
      <Tabs />
    </Show>
  );
};
